var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.$style.img,attrs:{"src":_vm.basePath + 'n8n-logo.svg',"alt":"n8n.io"}})}
var staticRenderFns = []

export { render, staticRenderFns }